import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import * as styles from './input-box.styles';

type Props = {
  children: ReactNode;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  focused: boolean;
  hasError: boolean;
};

export const InputBox = ({
  children,
  startAdornment = null,
  endAdornment = null,
  focused,
  hasError,
}: Props) => {
  const theme = useTheme();

  return (
    <div
      css={[styles.box(theme), focused && styles.focused(theme), hasError && styles.error(theme)]}>
      {startAdornment}
      {children}
      {endAdornment}
    </div>
  );
};
